import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ControlContainer, FormBuilder, FormGroup, FormGroupDirective } from '@angular/forms';
import { ServicesFilterConfig } from 'src/app/modules/shared/models/section-config.model';


@Component({
    selector: 'services-filter-configuration',
    templateUrl: 'services-filter-configuration.component.html',
    styleUrls: ['services-filter-configuration.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ServicesFilterConfigurationComponent implements OnInit {
    @Input() parentFormGroup: FormGroup;
    @Input() servicesFilterConfig: ServicesFilterConfig;

    form: FormGroup;

    constructor(private fb: FormBuilder) { }

    ngOnInit(): void {
        this.addControls();
    }

    private addControls(): void {
        const existingForm = this.parentFormGroup.get('servicesFilterConfig');
        if (existingForm instanceof FormGroup) {
            this.form = existingForm;
            return;
        }

        this.form = this.fb.group({
            show: this.fb.control(this.servicesFilterConfig?.show),
            specialPlaceholderPath: this.fb.control(this.servicesFilterConfig?.specialPlaceholderPath)
        });

        this.parentFormGroup.setControl('servicesFilterConfig', this.form);
    }
}
